<template>
  <div>
    <a-spin :spinning="loading">
      <div class="card">
        <div class="card-body">
          <h5 class="mb-4">
            <strong>General settings</strong>
          </h5>
          <a-row>
            <a-col :xs="{ span: 24 }" :sm="{ span: 12 }">
              <a-form-model ref="ruleForm" :model="form" :rules="rules">
                <a-form-model-item
                  ref="name"
                  prop="name"
                  :label-col="labelCol"
                  :wrapper-col="wrapperCol"
                  label="Name"
                >
                  <a-input v-model="form.name" />
                </a-form-model-item>

                <a-form-model-item
                  :label-col="labelCol"
                  :wrapper-col="wrapperCol"
                  label="VAT code"
                >
                  <a-input v-model="form.vatCode" />
                </a-form-model-item>

                <a-form-model-item
                  :label-col="labelCol"
                  :wrapper-col="wrapperCol"
                  label="Bank name"
                >
                  <a-input v-model="form.bankName" />
                </a-form-model-item>

                <a-form-model-item
                  :label-col="labelCol"
                  :wrapper-col="wrapperCol"
                  label="Bank account nr"
                >
                  <a-input v-model="form.bankAccount" />
                </a-form-model-item>

                <a-form-model-item
                  :label-col="labelCol"
                  :wrapper-col="wrapperCol"
                  label="Address line 1"
                >
                  <a-input v-model="form.addressLine1" />
                </a-form-model-item>

                <a-form-model-item
                  :label-col="labelCol"
                  :wrapper-col="wrapperCol"
                  label="Address line 2"
                >
                  <a-input v-model="form.addressLine2" />
                </a-form-model-item>

                <a-form-model-item
                  :label-col="labelCol"
                  :wrapper-col="wrapperCol"
                  label="ZIP code"
                >
                  <a-input v-model="form.zipCode" />
                </a-form-model-item>

                <a-form-model-item
                  :label-col="labelCol"
                  :wrapper-col="wrapperCol"
                  label="City"
                >
                  <a-input v-model="form.city" />
                </a-form-model-item>

                <a-form-model-item
                  :label-col="labelCol"
                  :wrapper-col="wrapperCol"
                  label="Country"
                >
                  <a-input v-model="form.country" />
                </a-form-model-item>

                <a-form-model-item
                  :label-col="labelCol"
                  :wrapper-col="wrapperCol"
                  label="Unit of measure"
                >
                  <a-input v-model="form.unitOfMeasure" />
                </a-form-model-item>

                <a-form-model-item
                  :label-col="labelCol"
                  :wrapper-col="wrapperCol"
                  label="Minimum bid"
                >
                  <a-input-number
                    v-model="form.minimumBid"
                    style="width: 200px"
                  />
                </a-form-model-item>
                <h5 class="mb-4">
                  <strong>Email settings</strong>
                </h5>
                <a-form-model-item
                  :label-col="labelCol"
                  :wrapper-col="wrapperCol"
                  label="Email"
                >
                  <a-input v-model="form.email" />
                </a-form-model-item>

                <a-form-model-item
                  :label-col="labelCol"
                  :wrapper-col="wrapperCol"
                  label="Server"
                >
                  <a-input v-model="form.server" />
                </a-form-model-item>

                <a-form-model-item
                  :label-col="labelCol"
                  :wrapper-col="wrapperCol"
                  label="Port"
                >
                  <a-input-number v-model="form.port" />
                </a-form-model-item>

                <a-form-model-item
                  :label-col="labelCol"
                  :wrapper-col="wrapperCol"
                  label="User"
                >
                  <a-input v-model="form.emailUser" />
                </a-form-model-item>

                <a-form-model-item
                  :label-col="labelCol"
                  :wrapper-col="wrapperCol"
                  label="Password"
                  style="width: 100%"
                >
                  <a-input type="password" v-model="form.emailPassword" />
                </a-form-model-item>
                <a-button @click="onSubmit" class="btn btn-success float-right">
                  Save
                </a-button>
              </a-form-model>
            </a-col>
          </a-row>
        </div>
      </div>
    </a-spin>
  </div>
</template>

<script>
import Vue from 'vue'
import { Button, Col, Row, Space } from 'ant-design-vue'
Vue.use(Space, Row, Col, Button)

import { SettingsService } from '@/services/api'

const labelCol = {
  xs: { span: 24 },
  sm: { span: 4 },
}
const wrapperCol = {
  xs: { span: 24 },
  sm: { span: 20 },
}

export default {
  props: {},
  data: function () {
    return {
      labelCol,
      wrapperCol,
      loading: true,
      rules: {},
      form: {
        name: '',
        vatCode: null,
        bankName: null,
        bankAccount: null,
        addressLine1: null,
        addressLine2: null,
        zipCode: null,
        city: null,
        country: null,
        unitOfMeasure: null,
        minimumBid: null,
        email: null,
        server: null,
        port: null,
        emailUser: null,
        emailPassword: null,
      },
    }
  },
  methods: {
    onSubmit() {
      this.$refs.ruleForm.validate((valid) => {
        if (valid) {
          this.loading = true

          var dataToSend = {
            name: this.form.name,
            bankName: this.form.bankName,
            bankAccount: this.form.bankAccount,
            addressLine1: this.form.addressLine1,
            addressLine2: this.form.addressLine2,
            zipCode: this.form.zipCode,
            city: this.form.city,
            country: this.form.country,
            vatCode: this.form.vatCode,
            unitOfMeasure: this.form.unitOfMeasure,
            minimumBid: this.form.minimumBid,
            email: this.form.email,
            serverName: this.form.server,
            port: this.form.port,
            emailUser: this.form.emailUser,
            emailPassword: this.form.emailPassword,
          }

          SettingsService.update(1, dataToSend).then((response) => {
            this.$notification.success({
              message: 'Company update',
              description: `Company details have been updated successfully.`,
            })
            this.getData()
          })
        } else {
          console.log('error submit!!')
          return false
        }
      })
    },
    getData() {
      SettingsService.get(1).then((response) => {
        this.form.name = response.data.data.name
        this.form.bankName = response.data.data.bankName
        this.form.bankAccount = response.data.data.bankAccount
        this.form.addressLine1 = response.data.data.addressLine1
        this.form.addressLine2 = response.data.data.addressLine2
        this.form.zipCode = response.data.data.zipCode
        this.form.city = response.data.data.city
        this.form.country = response.data.data.country
        this.form.vatCode = response.data.data.vatCode
        this.form.unitOfMeasure = response.data.data.unitOfMeasure
        this.form.minimumBid = response.data.data.minimumBid

        this.form.email = response.data.data.email
        this.form.server = response.data.data.server
        this.form.port = response.data.data.port
        this.form.emailUser = response.data.data.emailUser
        this.form.emailPassword = response.data.data.emailPassword

        this.loading = false
      })
    },
  },
  watch: {},
  computed: {
    // a computed getter
  },
  mounted() {
    this.getData()
  },
}
</script>
